<template>
  <div class="update-log-container">
    <!-- 标题区域 -->
    <div class="log-header">
      <h2 class="log-title">📜 永无止境 - 完整更新日志</h2>
      <div class="current-version">
        <span class="version-tag">当前版本: v1.20.2</span>
        <span class="version-date">更新日期: 2025-12-29</span>
      </div>
    </div>

    <!-- 重要公告区域 -->
    <div class="important-section">
      <div class="section-title">
        <Icon type="ios-megaphone" />
        <span>重要公告</span>
      </div>
      <div class="section-content">
        <Alert type="warning" show-icon>
          <div slot="desc">
            <p>进群可以免费领取兑换码 QQ群: <strong>808647555</strong></p>
            <div class="code-list">
              <div><strong>新手礼包：</strong>202408010DFXXNMGS3 (内含真理助力前期)</div>
              <div><strong>洗髓丹：</strong>2001250000CA4G211AW2</div>
              <div><strong>扩充礼包：</strong>20102300008FGTP8C65P (扩充空间+洗髓丹)</div>
              <div><strong>10级礼包：</strong>201111000076ZS79XZ54 (内含阴阳两仪佩)</div>
            </div>
          </div>
        </Alert>

        <Collapse simple class="tips-collapse">
          <Panel name="1">
            游戏重要提示
            <div slot="content">
              <ul class="simple-list">
                <li>本游戏难度较高，前期以升级为主</li>
                <li>打不过第一张图可领取新手礼包</li>
                <li>等级≠实力，装备和境界更重要</li>
                <li>真灵21级可学习第二个神通</li>
                <li>离线挂机需5天内重新选择地图</li>
              </ul>
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>

    <!-- 历史版本 -->
    <div class="version-section">
      <div class="section-title">
        <Icon type="ios-time" />
        <span>完整版本历史</span>
        <span class="total-versions">共 {{ totalVersions }} 个版本</span>
      </div>

      <div class="version-content">
        <!-- 最新版本 -->
        <div class="version-item highlight">
          <div class="version-header">
            <h3 class="version-title">
              <span class="version-number">v1.20.2</span>
              <span class="version-date">2025-12-29</span>
              <Tag color="error" size="small">最新</Tag>
            </h3>
          </div>
          <ul class="change-list">
            <li>更新宗门大比，周一到周三报名，周四宗门大比排名奖励发放</li>
            <li>真灵游历系统更新，第三真灵栏解放</li>
            <li>开启篝火祈福活动，产出最新版本法器及历史活动材料</li>
          </ul>
        </div>

        <!-- v0.70系列 -->
        <div class="version-item">
          <div class="version-header">
            <h3 class="version-title">
              <span class="version-number">v0.70.2</span>
              <span class="version-date">2024-09-08</span>
              <Tag color="primary" size="small">重大更新</Tag>
            </h3>
          </div>
          <ul class="change-list">
            <li class="major">开启第二版游戏，大量新属性系统（连击/暴击/反击/破甲）</li>
            <li class="major">新增八大灵根元素系统</li>
            <li class="major">开启四大宗门</li>
          </ul>
        </div>

        <!-- v0.50系列 -->
        <div class="version-item">
          <div class="version-header">
            <h3 class="version-title">
              <span class="version-number">v0.50.2</span>
              <span class="version-date">2024-04-08</span>
            </h3>
          </div>
          <ul class="change-list">
            <li class="major">新增宗门切磋功能</li>
            <li class="major">新增宗门boss及相关奖励</li>
          </ul>
        </div>

        <div class="version-item">
          <div class="version-header">
            <h3 class="version-title">
              <span class="version-number">v0.50.1</span>
              <span class="version-date">2024-03-17</span>
            </h3>
          </div>
          <ul class="change-list">
            <li class="major">新增锻造图纸功能</li>
            <li class="major">新增委托锻造（同时锻造3个）</li>
            <li>福源值可触发额外成功率20%-30%</li>
          </ul>
        </div>

        <!-- v0.11系列 -->
        <div class="version-item">
          <div class="version-header">
            <h3 class="version-title">
              <span class="version-number">v0.11.9</span>
              <span class="version-date">2023-11-15</span>
            </h3>
          </div>
          <ul class="change-list">
            <li class="major">排行榜修复</li>
            <li class="major">黑市重新开启（GM上架）</li>
          </ul>
        </div>

        <div class="version-item">
          <div class="version-header">
            <h3 class="version-title">
              <span class="version-number">v0.11.8</span>
              <span class="version-date">2023-11-10</span>
            </h3>
          </div>
          <ul class="change-list">
            <li class="major">词缀可以重新洗练</li>
            <li>宠物蛋可丢弃</li>
            <li>强化装备按一定比例回收</li>
            <li>预告下次大更新：宗门/爬塔/N角色</li>
          </ul>
        </div>

        <!-- 继续添加更多版本 -->
        <Collapse simple>
          <Panel name="more">
            查看更多历史版本 (v0.11.7 - v0.1)
            <div slot="content">
              <!-- v0.11.7 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.7</span>
                    <span class="version-date">2023-11-02</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">真灵已加强</li>
                  <li class="major">增加金币副本</li>
                </ul>
              </div>

              <!-- v0.11.6 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.6</span>
                    <span class="version-date">2023-10-25</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>部分神通暂时移除</li>
                  <li>预计下周实装共鸣系统</li>
                  <li>预计下下周实装黑市系统</li>
                  <li>下次上线共鸣和真灵放生功能</li>
                  <li>真灵上线，升级问题待解决</li>
                </ul>
              </div>

              <!-- 继续添加所有版本 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.5</span>
                    <span class="version-date">2023-10-25</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>部分神通暂时移除</li>
                  <li>预计下周实装共鸣系统</li>
                  <li>预计下下周实装黑市系统</li>
                  <li>真灵大幅加强等待实装</li>
                </ul>
              </div>

              <!-- 继续添加... 直到 v0.1 -->
              <!-- v0.11.7 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.7</span>
                    <span class="version-date">2023-11-02</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">真灵已加强</li>
                  <li class="major">增加金币副本</li>
                </ul>
              </div>

              <!-- v0.11.6 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.6</span>
                    <span class="version-date">2023-10-25</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>部分神通暂时移除</li>
                  <li>预计下周实装共鸣系统</li>
                  <li>预计下下周实装黑市系统</li>
                  <li>下次上线共鸣和真灵放生功能</li>
                  <li>真灵上线，升级问题待解决</li>
                </ul>
              </div>

              <!-- v0.11.5 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.5</span>
                    <span class="version-date">2023-10-25</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>部分神通暂时移除</li>
                  <li>预计下周实装共鸣系统</li>
                  <li>预计下下周实装黑市系统</li>
                  <li>真灵大幅加强等待实装</li>
                </ul>
              </div>

              <!-- v0.11.4 (2021) -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.4</span>
                    <span class="version-date">2021-01-14</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">气血神通：血量按照最初血量计算伤害</li>
                  <li class="major">宠物蛋解封，可生产真灵</li>
                  <li>真灵栏更新</li>
                </ul>
              </div>

              <!-- v0.11.4 (2020) -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.4</span>
                    <span class="version-date">2020-12-14</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">前20级怪物属性大幅度削弱</li>
                  <li>20级后怪物：血量大幅度提升，攻击下降，防御小幅提升</li>
                </ul>
              </div>

              <!-- v0.11.3 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.3</span>
                    <span class="version-date">2020-12-14</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">12月14号删档测试</li>
                  <li>期间主要准备地图、优化、调整</li>
                </ul>
              </div>

              <!-- v0.11.2 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.2</span>
                    <span class="version-date">2020-12-01</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增批量合成功能</li>
                  <li class="major">新增批量使用功能</li>
                </ul>
              </div>

              <!-- v0.11.1 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.1</span>
                    <span class="version-date">2020-11-27</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增批量购买功能</li>
                  <li class="major">新增物品合成功能</li>
                </ul>
              </div>

              <!-- v0.11.0 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.11.0</span>
                    <span class="version-date">2020-11-25</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增境界系统（可以大幅度提升属性）</li>
                </ul>
              </div>

              <!-- v0.10.9 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.9</span>
                    <span class="version-date">2020-11-24</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增55-60级装备（已加入55-60级地图）</li>
                  <li>装备强化：30-60级紫以下装备强化材料少量削减</li>
                  <li>红色装备强化提升效果提高</li>
                  <li class="major">兑换码礼包：
                    <div style="margin: 8px 0; padding: 8px; background: #f8f9fa; border-radius: 6px;">
                      <span>60级装备礼包：</span>
                      <code>201124000079MXKT2H4H</code>
                    </div>
                    <div style="margin: 8px 0; padding: 8px; background: #f8f9fa; border-radius: 6px;">
                      <span>强化材料礼包：</span>
                      <code>201124000079Y7BY4F14</code>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- v0.10.8 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.8</span>
                    <span class="version-date">2020-11-16</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">组队副本正式上线</li>
                  <li>组队副本必须满3个人才能进行</li>
                </ul>
              </div>

              <!-- v0.10.7 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.7</span>
                    <span class="version-date">2020-11-13</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">组队功能上线（战斗功能待完善）</li>
                  <li>战斗调整：buff可叠加</li>
                </ul>
              </div>

              <!-- v0.10.6 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.6</span>
                    <span class="version-date">2020-11-11</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增玩家编号（用于问题反馈和组队）</li>
                  <li>更新上传头像功能（点击图片即可）</li>
                  <li>新增自动战斗功能（按角色ID记录最近地图）</li>
                  <li>增强持续伤害buff：从每回合单次伤害改为怪力道攻击击次数</li>
                  <li>反击增强：无视防御并可暴击</li>
                </ul>
              </div>

              <!-- v0.10.5 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.5</span>
                    <span class="version-date">2020-11-10</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增装备对比功能</li>
                </ul>
              </div>

              <!-- v0.10.4 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.4</span>
                    <span class="version-date">2020-11-09</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>用户体验优化</li>
                  <li>排行榜和在线玩家列表移至导航条</li>
                </ul>
              </div>

              <!-- v0.10.3 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.3</span>
                    <span class="version-date">2020-11-07</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>每一点灵力转化的真气值削弱</li>
                  <li>力道加的攻击力增强</li>
                  <li>实装命中、闪避、暴击伤害属性</li>
                  <li class="major">装备随机属性浮动</li>
                  <li class="major">装备等级限制</li>
                </ul>
              </div>

              <!-- v0.10.2 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.2</span>
                    <span class="version-date">2020-11-05</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">关闭灵石直接兑换功能</li>
                  <li>商店新增好运袋道具</li>
                  <li>装备等级限制，功能道具等级使用限制</li>
                </ul>
              </div>

              <!-- v0.10.1 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.10.1</span>
                    <span class="version-date">2020-11-04</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增4个神通技能</li>
                </ul>
              </div>

              <!-- v0.9 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.9</span>
                    <span class="version-date">2020-11-01</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">开放装备强化系统</li>
                </ul>
              </div>

              <!-- v0.8 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.8</span>
                    <span class="version-date">2020-10-30</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">新增自动出售功能</li>
                  <li>新增装备锁定功能</li>
                </ul>
              </div>

              <!-- v0.7 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.7</span>
                    <span class="version-date">2020-10-27</span>
                  </h3>
                </div>
                <ul class="change-list" style="max-height: 300px; overflow-y: auto;">
                  <li class="major">新增等级排行榜</li>
                  <li>新增在线挂机玩家列表</li>
                  <li>新增灵石排行榜和金币排行榜</li>
                  <li>1-50级装备属性数据小幅度调整</li>
                  <li>新增：1-60级法系武器装备</li>
                  <li>新增：40-60级物理武器装备</li>
                  <li>新增：30-50级戒指，30-50级绶带</li>
                  <li class="major">新增法系主动神通：落雷，雷击，火球，大火球，极寒风暴，寥落九天-天惩</li>
                  <li>新增法系被动神通：冥思</li>
                  <li class="major">新增物理主动神通：连斩，疾风斩，真气爆发</li>
                  <li>新增物理被动神通：好战</li>
                  <li>新增50-60级地图，新增50-60级怪物</li>
                  <li>1-40级地图，怪物，装备爆率小幅度调整</li>
                  <li>煌龙炎月斩、九转凤鸣杀神通爆出地点由20级地图变更至50级新地图"云梦泽"</li>
                </ul>
              </div>

              <!-- v0.6 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.6</span>
                    <span class="version-date">2020-10-26</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>修复挂机可能会异常结束的问题</li>
                  <li class="major">界面大修改</li>
                  <li>修复全体神通在第二回合后无法攻击全部敌人的问题</li>
                  <li>补全灵力体系攻击（需要装备灵力装备进行测试）</li>
                </ul>
              </div>

              <!-- v0.5 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.5</span>
                    <span class="version-date">2020-10-23</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">增加道具使用功能（洗点药水、储物空间扩充）</li>
                  <li class="major">增加兑换码功能</li>
                </ul>
              </div>

              <!-- v0.4 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.4</span>
                    <span class="version-date">2020-10-22</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>修复经验值计算问题</li>
                </ul>
              </div>

              <!-- v0.3 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.3</span>
                    <span class="version-date">2020-10-21</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>怪物暴击率调整：普通怪物20%，特殊怪物20%及以上</li>
                  <li>怪物暴击伤害从200%下降到150%</li>
                  <li>加强绶带、戒指、项链属性，灵力和法力值加成更多</li>
                  <li>增加怪物前缀系统，随机让怪物属性提高或降低</li>
                  <li class="major">增加地图掉落表功能</li>
                  <li>优化地图切换功能</li>
                  <li>全部怪物生命值下降10%</li>
                  <li class="major">增加一键兑换灵石功能</li>
                </ul>
              </div>

              <!-- v0.2 -->
              <div class="version-item">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.2</span>
                    <span class="version-date">2020-10-20</span>
                  </h3>
                </div>
                <ul class="change-list">
                  <li class="major">增加修改密码功能</li>
                  <li class="major">增加神通升级功能</li>
                  <li>修复装备防御力显示问题（实际有防御力但未显示）</li>
                  <li>预告：兑换码功能、强化装备系统（最高强化10次）</li>
                </ul>
              </div>

              <!-- v0.1 - 初始版本 -->
              <div class="version-item highlight">
                <div class="version-header">
                  <h3 class="version-title">
                    <span class="version-number">v0.1</span>
                    <span class="version-date">2020-10-19</span>
                    <Tag color="red" size="small">初始版本</Tag>
                  </h3>
                </div>
                <ul class="change-list">
                  <li>修复主动神通不能脱下的问题</li>
                  <li>修复储物空间超出时底部留白的问题</li>
                  <li>修复手机端出现白边的问题</li>
                  <li>修改人力道攻击击显示为橙色，怪力道攻击击显示为蓝色</li>
                  <li>战斗间隙时间增加2秒，方便查看掉落物品</li>
                </ul>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer-section">
      <div class="section-title">
        <Icon type="ios-chatbubbles" />
        <span>意见反馈</span>
      </div>
      <div class="feedback-content">
        <p>如果您有任何建议或发现bug，欢迎反馈：</p>
        <div class="feedback-buttons">
          <Button type="primary" icon="ios-chatboxes" @click="joinQQGroup">
            加入QQ群：808647555
          </Button>
          <Button type="info" icon="ios-document" @click="openFeedbackForm">
            填写反馈表单
          </Button>
        </div>
        <p class="copyright">© 2020-2025 永无止境 · 开发团队</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateLog",
  data() {
    return {
      totalVersions: 34
    };
  },
  methods: {
    joinQQGroup() {
      window.open('https://qm.qq.com/q/YpJk6tssE5', '_blank');
    },

    openFeedbackForm() {
      window.open('https://docs.qq.com/form/page/DUVVYZFNSWEtjYldU', '_blank');
    }
  }
};
</script>

<style scoped>
.update-log-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* 头部样式 */
.log-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #1890ff, #36cfc9);
  border-radius: 10px;
  color: white;
}

.log-title {
  font-size: 28px;
  margin-bottom: 15px;
}

.current-version {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.version-tag {
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: bold;
}

.version-date {
  opacity: 0.9;
  line-height: 34px;
}

/* 通用区块样式 */
.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  font-size: 20px;
  color: #1890ff;
  border-bottom: 2px solid #e8e8e8;
  padding-bottom: 10px;
}

.section-title .ivu-icon {
  font-size: 20px;
}

.total-versions {
  margin-left: auto;
  font-size: 14px;
  color: #666;
  background: #f0f0f0;
  padding: 2px 10px;
  border-radius: 10px;
}

/* 重要公告 */
.important-section {
  margin-bottom: 30px;
}

.section-content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.code-list {
  margin-top: 10px;
  padding-left: 20px;
}

.code-list div {
  margin: 5px 0;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-size: 14px;
}

.tips-collapse {
  margin-top: 20px;
}

.simple-list {
  padding-left: 20px;
  margin: 10px 0;
}

.simple-list li {
  margin: 8px 0;
  color: #666;
}

/* 版本列表 */
.version-section {
  margin-bottom: 30px;
}

.version-content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.version-item {
  margin-bottom: 25px;
  padding: 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.version-item:hover {
  border-color: #1890ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.1);
}

.version-item.highlight {
  border: 2px solid #ff4d4f;
  background: linear-gradient(135deg, #fff2e8, #ffe7e7);
}

.version-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.version-title {
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 0;
  font-size: 18px;
  flex-wrap: wrap;
}

.version-number {
  font-weight: bold;
  color: #1890ff;
}

.version-date {
  color: #666;
  font-size: 14px;
}

.change-list {
  padding-left: 20px;
  margin: 0;
}

.change-list li {
  margin: 10px 0;
  padding: 8px 0;
  color: #555;
  line-height: 1.6;
  border-bottom: 1px dashed #eee;
}

.change-list li:last-child {
  border-bottom: none;
}

.change-list li.major {
  color: #F43e06;
  font-weight: bold;
}

/* 底部 */
.footer-section {
  margin-top: 40px;
}

.feedback-content {
  background: white;
  border-radius: 10px;
  padding: 25px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.feedback-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.copyright {
  margin-top: 20px;
  color: #999;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .update-log-container {
    padding: 10px;
  }

  .log-title {
    font-size: 22px;
  }

  .current-version {
    flex-direction: column;
    gap: 10px;
  }

  .version-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .feedback-buttons {
    flex-direction: column;
    align-items: center;
  }

  .section-title {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/updateLog.vue